module.exports = __webpack_public_path__ + "img/Charles.76b52674.png";